import { VmIcons } from "@/icons"
import { IconTextCell } from "@/molecules/IconTextCell"

import styles from "./InstanceCell.module.scss"

import type { getVirtualMachineTabData } from "@/pages/DiscoveryPage/application/virtual-machine-inventory/useVirtualMachine.selector"

export const InstanceCell = (
  text: string,
  record: ReturnType<typeof getVirtualMachineTabData>["data"][number]
) => (
  <IconTextCell
    icon={
      <VmIcons
        data-tooltip-content={record.subjectType}
        type={record.subjectType}
        className={styles.icon}
      />
    }
    text={text}
    classes={{ container: styles.text }}
  />
)
